<template>
  <DrawerVue :refreshDisplay="refreshDisplay" :scale="1.7">
    <UserEditContentVue
      :refreshDisplay="refreshDisplay"
      :userData="userData"
      :listView="listView"
      :readonly="readonly"
      @close="close"
    />
  </DrawerVue>
</template>

<script>
import UserEditContentVue from "./UserEditContent.vue";

export default {
  props: ["refreshDisplay", "userData", "listView", "readonly"],
  emits: ["close"],

  data() {
    return {};
  },

  components: {
    UserEditContentVue,
  },

  methods: {
    close(data) {
      this.$emit("close", data);
    },
  },

  mounted() {},
};
</script>
